// extracted by mini-css-extract-plugin
export default {"l":"f06c78e76c"};